import React, { FunctionComponent } from 'react';
import { Provider } from './context';

export default async function workpatternsLDProvider() {
  const LDProvider: FunctionComponent = ({ children }) => {
    const ldData = {
      flags: {},
      ldClient: null,
    };

    return <Provider value={ldData}>{children}</Provider>;
  };

  return LDProvider;
}
